/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Thu May 09 2024
 **/

import { atom } from "jotai";

export const modalListAtom = atom<DesignStuff.Modal.List>([]);
export const modalDimensionsAtom = atom<DesignStuff.Modal.State["dimensions"]>({
	width: "auto",
	height: "auto"
});
export const modalEventListAtom = atom<{ [id: string]: DesignStuff.Modal.HandlerEvent }>({});
